// extracted by mini-css-extract-plugin
module.exports = {"item":"LandingsAccordion_item__Vi5Ec","header":"LandingsAccordion_header__0U5UT","description":"LandingsAccordion_description__1Bs3U","body":"LandingsAccordion_body__XG5w0"};